<template>
    <el-drawer 
        title="新增昵称" 
        :visible.sync="nicknameVisible" 
        :before-close="closeDialog" 
        size="auto" 
        class="punish-box"
    >
        <div class="drawer-content">
            <el-form :model="nicknameForm"  ref="nicknameForm">
                
				<el-form-item  prop="keywords" label="昵称:" :rules="[{required: true, message: '请填写昵称'}]">
					<el-input v-model="nicknameForm.keywords"  type="text" size="medium"  maxlength="100" ></el-input>
				</el-form-item>                
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="closeDialog">取 消</el-button>
            <el-button type="primary" @click="submitForm" :loading="submitLoading">确认</el-button>
        </div>
    </el-drawer>
</template>

<script>
const defaultFormData = {
    keywords: ''   
}
export default {
    props: {
        nicknameVisible: {
            type: Boolean,
            default: false
        }
		
    },
    data(){       
      return {
		submitLoading: false,		
        nicknameForm: {
            ...defaultFormData
		}    	
      }  
    },
    watch:{
       
    },
    methods: {
        submitForm(){
			
            this.$refs['nicknameForm'].validate((valid) => {
                if(valid){
                    this.submitLoading = true;
                    this.$request({
                        url: '/nicknameDisabled/add',
                        method: "POST",
                        params: {...this.nicknameForm }
                    }).then(res=>{
                        const {state, msg} = res.data;
                        if (state == 1) {
                            this.$message.success('操作成功');
                            this.closeDialog();
                            this.$emit('update');
                        } else {
                            this.$message.error(msg || "请求失败");
                        }
                    }).catch(() => {
                        this.$message.error("请求错误");
                    }).finally(()=>{
                        this.submitLoading = false;
                    })
                }
            })            
        },
        closeDialog(){
            this.$emit('update:nicknameVisible', false);
			this.nicknameForm = {...defaultFormData};
        }
    }
}
</script>